import { render, staticRenderFns } from "./BattlePower.vue?vue&type=template&id=6226e2bf&scoped=true&"
import script from "./BattlePower.vue?vue&type=script&lang=js&"
export * from "./BattlePower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6226e2bf",
  null
  
)

export default component.exports